import React from "react";
import {lighten, makeStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

import UpdateEscala from "./UpdateEscala";
import DeleteEscala from "./DeleteEscala";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 30,
    backgroundColor: lighten(theme.palette.background.paper, 0.1)
  },
  table: {
    minWidth: 650
  },
  check: {
    color: "green"
  },
  close: {
    color: "red"
  }
}));

export default function TabelaEscalas(props){
  const classes = useStyles();
  const onChangeItem = props.onChangeItem;
  const dataEscalas = props.dataEscalas;

  // console.log(dataEscalas);

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table className={classes.table} aria-label="escalas">
        <TableHead>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell align="left">Ativo</TableCell>
            <TableCell align="right">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataEscalas.map((escala, index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                {escala.nome}
              </TableCell>
              <TableCell component="th" scope="row">
                {escala.ativo ? (
                  <CheckIcon className={classes.check} />
                ) : (
                  <CloseIcon className={classes.close} />
                )}
              </TableCell>
              <TableCell align="left">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end"
                  }}
                >
                  <UpdateEscala
                    id={escala.id}
                    descricao={escala.nome}
                    dataDias={props.dataDias}
                    onChangeItem={onChangeItem}
                  />
                  <DeleteEscala
                    id={escala.id}
                    descricao={escala.nome}
                    onChangeItem={onChangeItem}
                  />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
